import { useEffect } from "react";
import { performTokenRefresh } from "../../client/api";

// Loaded in a hidden iframe by zapflow/farm-manager to keep the shared
// ll_sso_token cookie alive without ever giving them the refresh token
// itself (deliberately letslaunch-only - only this origin can read it
// out of localStorage). performTokenRefresh() already updates both
// localStorage's own token and the shared cookie; this page just needs
// to trigger it and report back to whichever app embedded it.
const SilentRefresh: React.FC = () => {
  useEffect(() => {
    (async () => {
      const newToken = await performTokenRefresh();
      window.parent.postMessage({ type: "ll-silent-refresh-done", ok: !!newToken }, "*");
    })();
  }, []);

  return null;
};

export default SilentRefresh;
